import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder for the event lineup in manual mode. The rows sit in a
// `list` target; when a drag ends on a different order, the new order of
// data-event-wine-id is written into hidden order[] inputs on the `form`
// target and the form is submitted (a Turbo form inside the lineup frame,
// so the server's redirect reloads just the lineup). A drag that lands
// where it started submits nothing: the server clears the grouping on
// every reorder, as legacy did, and a no-op should not. Mouse events
// rather than native drag-and-drop, so the gesture works the same on
// touch screens and under Selenium.
export default class extends Controller {
  static targets = ["list", "form", "inputs"]

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: ".trade-lineup-handle",
      animation: 150,
      forceFallback: true,
      fallbackTolerance: 3,
      onStart: () => { this.before = this.order() },
      onEnd: () => { if (this.order().join() !== this.before?.join()) this.submit() }
    })
  }

  order() {
    return [...this.listTarget.querySelectorAll("[data-event-wine-id]")].map((row) => row.dataset.eventWineId)
  }

  disconnect() {
    this.sortable?.destroy()
    this.sortable = null
  }

  submit() {
    const ids = this.order()
    const holder = this.inputsTarget
    holder.replaceChildren()
    ids.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "order[]"
      input.value = id
      holder.appendChild(input)
    })
    this.formTarget.requestSubmit()
  }
}
